import { request } from "@/interface/helper";

const str = "communityCategory";

export const communityCategory = {
  [`${str}`]: {
    getList: data => request({ data, method: "get", url: "/community/cate/list" }),
    add: data => request({ data, method: "post", url: "/community/cate/add" }),
    detail: data => request({ data, method: "post", url: "/community/cate/detail" }),
    edit: data => request({ data, method: "post", url: "/community/cate/modify" })
  }
};
